import { Component, Router } from 'llama'
import FaceDrawer from '../common/FaceDrawer'
import FacePortrait from './face/FacePortrait'
import OnboardingFooter from './face/OnboardingFooter'

import * as onboardingNameCss from 'bundle-text:./onboarding-name.css'
import OnboardingRoutes from './OnboardingRoutes'
import ApiClient from './api-client'

export default class OnboardingName extends Component {
  constructor (opt) {
    super({
      ...opt,
      css: [onboardingNameCss],
      html: () => `<div id="onboarding">
        <div id="onboarding-header">
          <canvas id="onboarding-portrait" width="340" height="340"></canvas>
        </div>
        <div id="onboarding-body">
          <form>
            <label>${this.context.onboarding.choose_name}</label>
            <input id="choose-name" type="text">
            <label>${this.context.onboarding.choose_description}</label>
            <textarea id="choose-description"></textarea>
          </form>
        </div>
        <div id="onboarding-footer"></div>
      </div>`
    })

    this.faceDrawer = new FaceDrawer()
  }

  init (params, path) {
    const { eventBus, context } = this
    this.addChildren(
      params, path,
      new FacePortrait({
        eventBus,
        context,
        box: 'onboarding-portrait'
      }),
      new OnboardingFooter({
        eventBus,
        context,
        box: 'onboarding-footer',
        back: () => this.emit(Router.GO, OnboardingRoutes.Face(OnboardingRoutes.Portrait)),
        next: () => this.emit(Router.GO, OnboardingRoutes.Register())
      })
    )

    const chooseName = this.gId('choose-name')
    const chooseDescription = this.gId('choose-description')

    const onboardingName = document.getElementById('onboarding-name')
    chooseName.value = onboardingName.value
    const onboardingDescription = document.getElementById('onboarding-description')
    chooseDescription.value = onboardingDescription.value

    let chooseNameTO
    chooseName.addEventListener('keyup', () => {
      if (chooseNameTO) clearTimeout(chooseNameTO)
      chooseNameTO = setTimeout(() => {
        this.emit(ApiClient.UPDATE_DATA, { name: chooseName.value.trim() }, () => {
          chooseName.value = chooseName.value.trim()
          onboardingName.value = chooseName.value.trim()
        })
      }, 500)
    })
    let chooseDescriptionTO
    chooseDescription.addEventListener('keyup', () => {
      if (chooseDescriptionTO) clearTimeout(chooseDescriptionTO)
      chooseDescriptionTO = setTimeout(() => {
        this.emit(ApiClient.UPDATE_DATA, { description: chooseDescription.value }, () => {
          onboardingDescription.value = chooseDescription.value
        })
      }, 500)
    })
  }
}
